import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { store } from './store'
import { toast } from 'react-toastify';
import {setAppBasePath} from './actions/currentTempSettingActions';
import{setProgramVersion} from './actions/currentUiSettingsActions';
import {clearToastList} from '../src/actions/currentToastActions';
import { useState  } from 'react';
import DelayedLoadingFallback from './components/general/DelayedLoadingFallback';
import './scss/style.scss';


const TheLayout = React.lazy(() => import('./containers/TheLayout'));
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

const getBasename = path => path.substr(0, path.lastIndexOf('/'));

const App = () => {

  const [myBase, setMyBaseState] = useState('/');

  React.useEffect(() => {   
    let _protocol = window.location.protocol;
    let _port = window.location.port;
    let _host = window.location.hostname;
    let _subPath = getBasename(window.location.pathname)
    
    let str = _protocol + '//' + _host;
    if(_port !== 443 && _port.length > 0) {  //
        str = str + ':' + _port        
    }
    str = str + '/' ;
    if(_subPath.lenght > 0) {      
      str = str + _subPath + '/';
    }

    store.dispatch(setAppBasePath(str));
    store.dispatch(setProgramVersion('5.49'));

    setMyBaseState(str);

    const myMessage = store.getState().currentToast.toastStack;
    
    if(myMessage !== null && myMessage[0] !== null && myMessage[0] !== '')
    {      
      for (let index = 0; index < myMessage.length; ++index) {        
        if( myMessage[index]['type'].toUpperCase() === 'INFO')
        {
          toast.info(myMessage[index]['message'], {theme: "colored"});
        }          
        else if( myMessage[index]['type'].toUpperCase() === 'ERROR')
        {            
          toast.error(myMessage[index]['message'], {theme: "colored"});
        }
        else if( myMessage[index]['type'].toUpperCase() === 'WARNING')
        {
          toast.warning(myMessage[index]['message'], {theme: "colored"});
        }
        else if( myMessage[index]['type'].toUpperCase() === 'SUCCESS')
        {
          toast.success(myMessage[index]['message'], {theme: "colored"});
        }
      };
    }

    store.dispatch(clearToastList(null));
  }, []);

   
  return (
    <>          
      <React.Suspense fallback={<DelayedLoadingFallback />}>
        <BrowserRouter basename={getBasename(window.location.pathname)} >                            
            <Switch>               
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />              
              
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              
              <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />              
            </Switch>        
        </BrowserRouter>
      </React.Suspense>
    </>
  );  

}

export default App;